import { storeWrapper } from '../storeWrapper'

const initialState = {
  wizardId: null,
  wizardConfig: [],
  wizardStagesById: {},
  wizardStagesByIndex: [],
  wizardStepsById: {},
  wizardStepsByIndex: [],
  currentStepStateId: null,
  wizardState: {},
  wizardIsComplete: false
}

export const useWizardStore = storeWrapper('useWizardStore', (set, get) => ({
  ...initialState,
  setWizardId: ({ wizardId }) => {
    set({ wizardId })
  },
  setWizardConfig: ({ wizardId, wizardConfig }) => {
    if (!wizardId || !wizardConfig) return

    const wizardStagesById = {}
    const wizardStagesByIndex = []
    const wizardStepsById = {}
    const wizardStepsByIndex = []

    wizardConfig.forEach((stage, index) => {
      stage.index = index
      wizardStagesById[stage.stageId] = stage
      wizardStagesByIndex.push(stage)

      stage.steps.forEach((step) => {
        step.index = wizardStepsByIndex.length
        step.stageId = stage.stageId
        wizardStepsById[step.uniqueId] = step
        wizardStepsByIndex.push(step)
      })
    })

    set({ wizardId, wizardStagesById, wizardStagesByIndex, wizardStepsById, wizardStepsByIndex, wizardConfig })
  },
  setCurrentStepStateId: (currentStepStateId) => set({ currentStepStateId }),
  setWizardIsComplete: (wizardIsComplete) => set({ wizardIsComplete }),
  setWizardState: ({ key, value }) => set({ wizardState: { ...get().wizardState, [key]: value } }),
  setWizardStateInBulk: (changes) => {
    changes.forEach(({ key, value }) => {
      set({ wizardState: { ...get().wizardState, [key]: value } })
    })
  },
  reset: () => {
    set({ wizardState: null })
    set(initialState)
  }
}))
